import { useTranslation } from 'react-i18next';
import { cn, ColorUtils, LsbUtils } from '@shared/utils';
import { InquiryStatus } from '@shared/api';
import { Text } from '@shared/widgets';

interface TravelStatusProps {
  className?: string;
  status: InquiryStatus;
}

export const TravelStatus = (props: TravelStatusProps) => {
  const { t } = useTranslation('travel');

  const color = ColorUtils.getTravelRequestStatusStyles(props.status);
  return (
    <Text className={cn('w-fit rounded-full px-2 py-1', color.bg, color.text, props.className)} nowrap weight='semibold' color='custom'>
      &bull; {t(`travelStatus.${LsbUtils.getInquiryStatusLabel(props.status)}`)}
    </Text>
  );
};
